import { SetAsReadProps } from '@/config/types';
import { apiConfig } from '@/services/api-config';

export default async function setAsRead(resp: SetAsReadProps) {
  return apiConfig
    .post('api/TerritoryAccess/set-as-read', resp)
    .then((response) => response.data)
    .catch(() => false);
}
